import { TranslateLoader } from "@ngx-translate/core";
import { LanguageService } from "@shared/services/language.service";
import { Observable } from "rxjs";

export class CustomI18nTranslateLoader implements TranslateLoader {
  constructor(private languageService: LanguageService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getTranslation(lang: string): Observable<any> {
    return this.languageService.getTranslation(lang);
  }
}
